export default class Cookie {
    static get(name: string): any {
        // @ts-ignore
        return new Map(document.cookie.split('; ').map(v => v.split('=').map(decodeURIComponent))).get(name);
    }
}
